import axios from 'axios'

export default {
  state: {
    banners_list: [],
  },
  getters: {
    getBanners: (s) => s.banners_list,
  },
  mutations: {
    setBanners: (s, list) => (s.banners_list = list),
  },
  actions: {
    fetchBanners(ctx, lang = 'ru') {
      // if (lang === 'be') lang = 'ru';
      return axios({
        method: 'GET',
        url: `api/v3/main-page/banners/items/?language=${lang}`,
        headers: {
          Authorization: null,
        },
      })
        .then((response) => {
          const list = response.data.results
          ctx.commit('setBanners', list)
        })
        .catch((error) => {
          console.error(error)
        })
    },
    fetchBannersGroup(ctx, lang = 'ru') {
      // if (lang === 'be') lang = 'ru';
      return axios({
        method: 'GET',
        url: `api/v3/main-page/banners/groups/?language=${lang}`,
        headers: {
          Authorization: null,
        },
      })
        .then((response) => {
          const list = response.data.results
          ctx.commit('setBanners', list)
        })
        .catch((error) => {
          console.error(error)
        })
    },
  },
}
